<template>
  <div class="container-custom moo-profile-page" :style="styleObject">
    <div class="content-custom" v-if="isLoadDone">
      <div class="col-12 profile-inner">
        <!-- Avatar / brand header (Advocado style) -->
        <section class="profile-hero" v-if="isLogined">
          <div class="profile-avatar-wrap">
            <div class="profile-avatar">
              <img :src="merchantLogo" alt="merchant" />
            </div>
            <button
              v-if="isLogined"
              class="profile-avatar-qr"
              type="button"
              aria-label="Show QR code"
              data-bs-toggle="modal"
              data-bs-target="#qrcode-modal-member"
            >
              <span class="material-icons-round">qr_code_2</span>
            </button>
          </div>
          <p class="profile-hero-name" v-if="isLogined">
            {{
              this.currentMember.name || this.currentMember.last_name
                ? (this.currentMember.name ? this.currentMember.name : "") +
                  " " +
                  (this.currentMember.last_name
                    ? this.currentMember.last_name
                    : "")
                : this.currentMember.phone_number
                ? this.currentMember.phone_number
                : ""
            }}
          </p>
          <p
            class="profile-hero-tier"
            v-if="isLogined && merchantMember.allow_setup_membership_tiering != 0"
            @click="gotoTierBenefit()"
          >
            {{
              merchantMember.current_tier_name
                ? merchantMember.current_tier_name
                : $t('profile.noTier')
            }}
          </p>
        </section>

        <!-- Points / tier card (Advocado style) -->
        <div class="card-body p-0" v-if="isLogined">
          <div
            v-if="merchantMember.allow_setup_membership_tiering != 0"
            class="profile-stat-card"
          >
            <div class="profile-stat-row">
              <div class="profile-stat" @click="gotoTransaction">
                <img
                  src="../assets/img/coins.png"
                  class="profile-stat-icon"
                  alt="balance"
                />
                <h2 class="profile-stat-value">
                  {{ merchantMember.amount_format }}
                </h2>
              </div>
              <div
                v-if="merchantMember.reward_type == rewardPoint"
                class="profile-stat"
                @click="gotoTransaction"
              >
                <img
                  :src="pointIcon"
                  class="profile-stat-icon"
                  alt="points"
                />
                <h2 class="profile-stat-value">
                  {{ merchantMember.point_format }}
                </h2>
              </div>
            </div>
            <div
              class="profile-stat-notice"
              v-if="merchantMember.notice_transaction_point_expiry.length > 0"
            >
              <div
                v-for="(
                  text, index
                ) in merchantMember.notice_transaction_point_expiry"
                :key="index"
              >
                <em v-html="text"></em>
              </div>
            </div>
            <div
              class="profile-stat-notice"
              v-if="merchantMember.notice_transaction_amount_expiry.length > 0"
            >
              <div
                v-for="(
                  text, index
                ) in merchantMember.notice_transaction_amount_expiry"
                :key="index"
              >
                <em v-html="text"></em>
              </div>
            </div>
            <div class="profile-progress-row">
              <div class="profile-progress-bar">
                <material-progress
                  :percentage="merchantMember.level_percentage"
                  variant="fill"
                  color="info"
                  style="height: 6px"
                />
              </div>
              <img
                v-if="merchantMember.tier_icon"
                :src="merchantMember.tier_icon"
                class="profile-tier-icon"
                alt="tier"
              />
            </div>
            <div
              class="profile-level-note"
              v-if="merchantMember.level_note"
              @click="gotoTierBenefit()"
            >
              <span>{{ merchantMember.level_note }}</span>
              <i class="material-icons-round">report</i>
            </div>
          </div>
        </div>
        <!-- Not signed in — Advocado empty state -->
        <template v-if="!isLogined">
          <div class="profile-page-header">
            <h1 class="profile-page-title">{{ $t('profile.title') }}</h1>
          </div>
          <section class="profile-empty">
            <div class="profile-empty-icon">
              <span class="material-icons-round">account_circle</span>
            </div>
            <h2 class="profile-empty-title">{{ $t('profile.notSignedInTitle') }}</h2>
            <p class="profile-empty-desc">
              {{ $t('profile.notSignedInDesc') }}
            </p>
            <button
              class="profile-save-btn"
              type="button"
              @click="gotoSignIn()"
            >
              {{ $t('profile.signIn') }}
            </button>
          </section>
        </template>

        <div class="profile-menu mt-3">
          <!-- The form this replaces used to sit open on the page and take most
               of a phone screen; it now lives in ModalUpdateProfile, the same
               component MyReward opens. -->
          <div v-if="isLogined" class="root_row" @click="openUpdateProfile()">
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >person</span
              >
            </div>
            <div class="root_row_child_text">
              {{ $t('profile.personalInformation') }}
            </div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <!-- <hr style="margin-top: 0px; margin-bottom: 0px" />
          <div class="root_row">
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >house</span
              >
            </div>
            <div class="root_row_child_text">Branch</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <hr style="margin-top: 0px; margin-bottom: 0px" /> -->
          <!-- <div class="root_row">
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >support</span
              >
            </div>
            <div class="root_row_child_text">Support Center</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <hr style="margin-top: 0px; margin-bottom: 0px" /> -->
          <!-- <div class="root_row">
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >hvac</span
              >
            </div>
            <div class="root_row_child_text">Terms & Conditions</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <hr style="margin-top: 0px; margin-bottom: 0px" /> -->
          <!-- <div class="root_row">
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >settings_applications</span
              >
            </div>
            <div class="root_row_child_text">Setting</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div> -->
          <!-- <hr style="margin-top: 0px; margin-bottom: 0px" /> -->
          <div
            v-if="isLogined && memberPermissions.includes('Top-up')"
            class="root_row"
            @click="gotoTopUp()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >account_balance_wallet</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.menuTopUp') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined && memberPermissions.includes('Transactions')"
            class="root_row"
            @click="gotoMyTransactions()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >receipt_long</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.menuTransactions') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined && !queue && memberPermissions.includes('My Rewards')"
            class="root_row"
            @click="gotoRewardCatalogue()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >card_giftcard</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('rewardCatalogue.title') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined && memberPermissions.includes('My Rewards')"
            class="root_row"
            @click="gotoMyVouchers()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >confirmation_number</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.menuMyVouchers') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined && memberPermissions.includes('Find Branches')"
            class="root_row"
            @click="gotoFindStores()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >place</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.menuFindBranches') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined && !queue"
            class="root_row"
            @click="handleRedirectCompletedOrdersForPayFirst()"
          >
            <div class="root_row_child">
              <span
                style="color: var(--color)"
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >check_circle</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.menuCompletedOrders') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
          <div
            v-if="isLogined"
            class="root_row root_row--logout"
            @click="handleLogout()"
          >
            <div class="root_row_child">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active md-30"
                >logout</span
              >
            </div>
            <div class="root_row_child_text">{{ $t('profile.logout') }}</div>
            <div class="root_row_child_icon">
              <span
                class="material-icons-round opacity-10 cursor-pointer text-center active"
                >navigate_next</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer v-if="isLoadDone">
      <Footer></Footer>
    </footer>
    <!-- Personal information, opened from the menu row above. Same component
         MyReward.vue uses, so the form exists in exactly one place. -->
    <ModalUpdateProfile
      v-if="isLogined && currentMember.id"
      :keyReload="keyReloadProfileModal"
      :member="currentMember"
      @update-success="getDataMember()"
    />

    <QrcodeMember :phoneNumber="memberPhone" />
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Footer from "@/common/Footer/OrderFooter";
import MemberService from "../services/member.service";
import MaterialProgress from "@/components/MaterialProgress.vue";
import QrcodeMember from "@/components/QrcodeMember.vue";
import ModalUpdateProfile from "./components/ModalUpdateProfile.vue";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import { gotoMemberLogin, localStorageName } from "@/config/utils";
import defaultLogo from "@/assets/img/logo.png";

export default {
  name: "sign-in",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Footer,
    MaterialProgress,
    QrcodeMember,
    ModalUpdateProfile,
  },
  data() {
    return {
      isLoadDone: false,
      snackbar: null,
      paymentMethod: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      message: "",
      merchantCode: "",
      branchCode: "",
      tableCode: "",
      isLogined: false,
      currentMember: {},
      // Bumped on every open so the modal re-reads `member` into its own form
      // instead of showing whatever was left from the previous time.
      keyReloadProfileModal: "reload",
      merchantMember: {},
      pointIcon: "",
      rewardPoint: 2,
      memberPhone: "",
      tableInfo: null,
      isOrderPayLater: false,
      pathType: "",
      queue: false,
      memberPermissions: [],
    };
  },
  watch: {
    progressPercentage() {
      this.updateProgressBarColor();
    },
  },
  created() {
    const merchantCode = this.$store.state.merchantCode;
    this.merchantCode = merchantCode ? `/${merchantCode}` : "";
    this.branchCode = this.$store.state.branchCode;
    this.pathType = this.$route.params.type;
    this.tableCode = this.$route.params.table_code;
    this.tableInfo = JSON.parse(
      localStorage.getItem(
        "table_" +
          (merchantCode || '').toLowerCase() +
          "_" +
          (this.branchCode || '').toLowerCase() +
          "_" +
          (this.tableCode || '').toLowerCase(),
        null
      )
    );
    this.queue = this.$route.query.queue ?? false;

    if (this.tableInfo) {
      if (this.tableInfo.stripe_connect) {
        this.isOrderPayLater = false;
      } else {
        this.isOrderPayLater = true;
      }
    } else {
      this.isOrderPayLater = false;
    }

    var memberInfoData = JSON.parse(
      localStorage.getItem(localStorageName("memberInfo"), "")
    );
    if (memberInfoData) {
      this.getDataMember();
      this.checkMemberPermissions();
      this.isLogined = true;
    } else {
      this.isLogined = false;
      this.isLoadDone = true;
    }
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.mainThemeColorTheme2
          ? this.$store.state.mainThemeColorTheme2
          : this.$store.state.color,
      };
    },
    merchantLogo() {
      return (
        this.$store.state.logoTheme2 ||
        localStorage.getItem(localStorageName("MERCHANT_LOGO")) ||
        defaultLogo
      );
    },
  },
  methods: {
    gotoSignIn() {
      // this.$router.push({ name: "SignIn", params: {} });
      gotoMemberLogin("profile", this.queue, "login");
      // window.open(process.env.VUE_APP_MEMBER_SITE_URL + this.merchantCode + "/sign-in?branch_code=" + this.branchCode + "&from=profile","_self");
    },
    handleLogout() {
      localStorage.clear();
      // this.merchantCode carries a leading slash (see created(), it is used to
      // build member-site URLs) — as a route param that slash is encoded to
      // %2F, producing /%2FA01/... So read the plain code from the store, the
      // same way gotoRewardCatalogue() does. `type` / `table_code` stay optional, so a
      // non-QR table-less session logs out to /{merchant}/{branch}/sign-in.
      var params = {
        merchant_code: this.$store.state.merchantCode,
        branch_code: this.branchCode,
      };
      if (this.$route.params.type) params.type = this.$route.params.type;
      if (this.tableCode) params.table_code = this.tableCode;
      this.$router.push({ name: "SignIn", params });
    },
    goBack() {
      this.$router.go(-1);
    },
    checkMemberPermissions() {
      MemberService.checkMemberPermissions().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.memberPermissions = response.data.data;
          }
        },
        () => {}
      );
    },
    // The catalogue — where a member spends points or wallet balance on a new
    // voucher. NOT MyReward: the bottom nav's 'rewards' tab already opens that,
    // so this row was a second door to the same screen.
    // this.merchantCode carries a leading slash (see created()), so the route
    // params come from the store / current route instead. The row is hidden in
    // queue mode, where checkUrlExpiry only whitelists Cover/Queue/Profile/MyCart.
    gotoRewardCatalogue() {
      this.$router.push({
        name: "RewardCatalogue",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    // The Top-up row opens MOO's own top-up screen instead of the external
    // member site, same reasoning as gotoRewardCatalogue() above.
    gotoTopUp() {
      this.$router.push({
        name: "TopUp",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    // The Transactions row opens MOO's own transaction-history screen instead
    // of the external member site, same reasoning as gotoTopUp() above.
    // The tier chip and the "level note" under the progress bar both open
    // MOO's own tier-benefit screen, same reasoning as gotoRewardCatalogue() above.
    gotoTierBenefit() {
      this.$router.push({
        name: "LoyaltyTierBenefit",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    // MOO's own branch finder, rather than gotoMemberPage() opening the member
    // site — the branches it lists are the ones you can order from right here.
    gotoFindStores() {
      this.$router.push({
        name: "FindStores",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    openUpdateProfile() {
      this.keyReloadProfileModal = String(Math.random());
      $(".show-modal-update-profile").click();
    },
    // The vouchers the member already holds — codes to show at the counter,
    // plus what is used, expired or still locked. Distinct from the catalogue
    // row above, which is where a member buys a new one.
    gotoMyVouchers() {
      this.$router.push({
        name: "MyVouchers",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    gotoMyTransactions() {
      this.$router.push({
        name: "MyTransactions",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    gotoMemberPage(path) {
      var url =
        process.env.VUE_APP_MEMBER_SITE_URL + this.merchantCode + "/" + path;

      window.open(url, "_blank");
    },
    async getDataMember() {
      this.isLoadDone = false;
      this.showLoader();

      try {
        const response = await MemberService.getMemberInfo(this.merchantCode);

        if (response.data.result.isSuccess) {
          this.currentMember = response.data.data.member;
          this.memberPhone = this.currentMember.phone_number;
          this.merchantMember = response.data.data.merchant_member;
          this.pointIcon = response.data.data.point_icon;
          this.isLoadDone = true;
        } else {
          this.snackbar = "danger";
          this.message = response.data.result.message;
          this.setTimeOutNotification();
        }
      } catch (error) {
        this.snackbar = "danger";
        this.message = error;
        this.setTimeOutNotification();
      }
      this.hideLoader();
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
    handleRedirectCompletedOrdersForPayFirst() {
      var url =
        location.protocol +
        "//" +
        location.host +
        "/" +
        this.$store.state.merchantCode;

      if (this.tableInfo) {
        url +=
          "/QR/" +
          this.branchCode +
          "/" +
          this.tableCode +
          "/completed-order-history-for-pay-first";
      } else {
        url += "/" + this.branchCode + "/completed-order-history-for-pay-first";
      }

      window.location.href = url;
    },
  },
};
</script>
<style scoped>
.root_child_name {
  display: inline-flex;
  gap: 10px;
}
.a_go_back {
  width: 10%;
  height: fit-content;
}
.text_go_back {
  color: black;
  height: fit-content;
}
.root_logout {
  width: 100%;
  position: absolute;
  bottom: 0px;
}
.root_child_logout {
  display: inline-flex;
  align-items: center;
  width: 100%;
  margin-top: 5px;
}
.btn_logout {
  width: 100%;
  background: orangered !important;
  color: white !important;
}
.root_row {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  height: 50px;
}
.root_row_child {
  width: 10%;
  text-align: center;
  display: flex;
}
.root_row_child_text {
  width: 80%;
  color: black;
  font-size: 16px;
}
.root_row_child_icon {
  width: 10%;
  text-align: center;
  display: flex;
}
.hello-name {
  color: black;
  height: fit-content;
  font-size: 25px;
  font-weight: 700;
}
.p-header {
  width: 100%;
  background: var(--color);
  padding: 15px;
}
input::placeholder {
  font-size: 15px;
  text-align: left;
  font-weight: 600;
  padding-left: 10px;
}
.visa {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.visaActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.master {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.masterActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.googlePay {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.googlePayActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.applePay {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.applePayActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.text-bold-500 {
  color: black;
  font-weight: 500;
}
.text-bold-400 {
  color: black;
  font-weight: 400;
}
.line {
  width: 100%;
  height: 5px;
  background: #bdbdbd;
}
.text-end {
  color: black;
  width: 20%;
  text-align: end;
}
.progress-bar {
  height: 20px;
  width: 100%;
}
.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.content-custom {
  flex: 1;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE / old Edge */
}
.content-custom::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
footer {
  background-color: white;
  padding-top: 10px;
}
/* ── MTH039 theme2 reskin — Advocado "My Profile" (docs/design/9profile).
   Hybrid layout: Advocado-style avatar hero + points/tier card + restyled
   menu list, while every MOO row/link and its @click stay intact. All rules
   are confined to .moo-profile-page (styles here are already scoped, but the
   wrapper keeps the intent explicit and consistent with the other theme2
   pages). Colours track the merchant Theme 2 var(--color) via color-mix
   tiers — never a hard-coded brown. See [[mth035-myreward-reskin]]. ── */
.moo-profile-page {
  --pf: var(--color);
  --pf-06: color-mix(in srgb, var(--color) 6%, #ffffff);
  --pf-10: color-mix(in srgb, var(--color) 10%, #ffffff);
  --pf-14: color-mix(in srgb, var(--color) 14%, #ffffff);
  --pf-muted: color-mix(in srgb, var(--color) 50%, #ffffff);
  font-family: "Plus Jakarta Sans", "Manrope", system-ui, sans-serif;
}
.moo-profile-page .content-custom {
  background: var(--pf-06);
}
.moo-profile-page .profile-inner {
  padding: 0 16px 8px;
}

/* Hero — centred brand avatar + name + tier */
.moo-profile-page .profile-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  margin-bottom: 20px;
}
.moo-profile-page .profile-avatar-wrap {
  position: relative;
}
.moo-profile-page .profile-avatar {
  width: 112px;
  height: 112px;
  border-radius: 9999px;
  overflow: hidden;
  border: 4px solid #ffffff;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(25, 28, 30, 0.14);
}
.moo-profile-page .profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.moo-profile-page .profile-avatar-qr {
  position: absolute;
  bottom: 2px;
  right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 9999px;
  background: var(--pf);
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(25, 28, 30, 0.2);
  cursor: pointer;
  transition: transform 0.15s ease;
}
.moo-profile-page .profile-avatar-qr:active {
  transform: scale(0.92);
}
.moo-profile-page .profile-avatar-qr .material-icons-round {
  font-size: 20px;
}
.moo-profile-page .profile-hero-name {
  margin: 16px 0 2px;
  font-weight: 800;
  font-size: 1.35rem;
  color: #1a1c1a;
  text-align: center;
}
.moo-profile-page .profile-hero-tier {
  cursor: pointer;
  margin: 0;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.02em;
  color: var(--pf);
  text-transform: uppercase;
}

/* Points / tier card */
.moo-profile-page .profile-stat-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 18px 20px;
  margin-bottom: 20px;
  box-shadow: 0 6px 18px rgba(25, 28, 30, 0.06);
}
.moo-profile-page .profile-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.moo-profile-page .profile-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.moo-profile-page .profile-stat-icon {
  height: 28px;
  width: auto;
}
.moo-profile-page .profile-stat-value {
  margin: 0;
  font-weight: 800;
  font-size: 1.4rem;
  color: #1a1c1a;
}
.moo-profile-page .profile-stat-notice {
  margin-top: 6px;
  font-size: 12px;
  color: var(--pf-muted);
}
.moo-profile-page .profile-progress-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}
.moo-profile-page .profile-progress-bar {
  flex: 1;
}
.moo-profile-page .profile-tier-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: contain;
}
.moo-profile-page .profile-level-note {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
  color: var(--pf-muted);
}
.moo-profile-page .profile-level-note i {
  color: var(--pf);
  font-size: 18px;
}

/* Personal information form (replaces the old "Update profile" row) */
.moo-profile-page .profile-save-btn {
  width: 100%;
  margin-top: 4px;
  padding: 13px 16px;
  border: none;
  border-radius: 9999px;
  background: var(--pf);
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(25, 28, 30, 0.12);
  transition: transform 0.15s ease;
}
.moo-profile-page .profile-save-btn:active {
  transform: scale(0.98);
}

/* Menu list — each MOO row becomes an Advocado list card */
.moo-profile-page .profile-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.moo-profile-page .root_row {
  height: auto;
  padding: 12px 14px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(25, 28, 30, 0.05);
  cursor: pointer;
  transition: transform 0.15s ease;
}
.moo-profile-page .root_row:active {
  transform: scale(0.99);
}
.moo-profile-page .root_row_child {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 9999px;
  background: var(--pf-14);
  align-items: center;
  justify-content: center;
}
.moo-profile-page .root_row_child .material-icons-round {
  color: var(--pf);
  font-size: 22px !important;
}
.moo-profile-page .root_row_child_text {
  flex: 1;
  width: auto;
  padding-left: 14px;
  font-weight: 600;
  font-size: 15px;
  color: #1a1c1a;
}
.moo-profile-page .root_row_child_icon {
  width: auto;
  align-items: center;
  justify-content: center;
}
.moo-profile-page .root_row_child_icon .material-icons-round {
  color: var(--pf-muted);
}

/* Logout — semantic red, kept from MOO */
.moo-profile-page .root_row--logout .root_row_child {
  background: color-mix(in srgb, #ba1a1a 12%, #ffffff);
}
.moo-profile-page .root_row--logout .root_row_child .material-icons-round {
  color: #ba1a1a;
}
.moo-profile-page .root_row--logout .root_row_child_text {
  color: #ba1a1a;
}

/* Not-signed-in empty state (Advocado) */
.moo-profile-page .profile-page-header {
  padding: 24px 4px 4px;
}
.moo-profile-page .profile-page-title {
  margin: 0;
  font-weight: 800;
  font-size: 1.5rem;
  line-height: 2rem;
  color: #1a1c1a;
}
.moo-profile-page .profile-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 40px 20px 20px;
}
.moo-profile-page .profile-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 9999px;
  background: var(--pf-06);
  margin-bottom: 4px;
}
.moo-profile-page .profile-empty-icon .material-icons-round {
  font-size: 36px;
  color: var(--pf);
}
.moo-profile-page .profile-empty-title {
  margin: 0;
  font-weight: 800;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #1a1c1a;
}
.moo-profile-page .profile-empty-desc {
  margin: 0 0 12px;
  max-width: 18rem;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--pf-muted);
}

/* MTH071 — the bottom nav must sit on the same tint as the scrolling body
   above it. .moo-bottom-nav (BottomNav.vue) has no background of its own, so
   colouring <footer> is what actually tints the bar. Its top shadow and
   rounded top corners are left alone — they are the intended divider. */
.moo-profile-page footer {
  background: var(--pf-06);
}
</style>
